import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikTextField from './FormikTextField';
import FormikSelect from './FormikSelect';

import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Modal from 'react-bootstrap/Modal';
import FormikErrorMessage from './FormikErrorMessage';
import { createUseStyles } from 'react-jss';
import Text from './Text';
import clsx from 'clsx';
import Button from './Button';
import FormikCheckbox from './FormikCheckbox';
import { RootState } from '../config/store';
import { changeStateOfClose, hideAuthModals, showContinueRegisterModal, showLoginModal, showRegisterModal } from '../actions/ui';
import { getAllCities, getAllCountries, registerUser } from '../services/ApiService';
import { setUser, loginLocally, setUsersFollow } from '../actions/auth';
import { formatJoiError } from '../lib/utils';
import { Area, City, Country, DetailsUserInfo, MainUserInfo, RegistrationInfo } from '../types';
import { pageTrack, track } from '../services/mixpanelService';
import SocialLogin from './SocialLogin';
import { getUserFollower } from '../services/ProfileService';
import { objectWithOutNull } from '../services/helpers';

export interface RegisterModalProps { }

const formSchema = Yup.object()
  .shape({
    // validation for full name(contain at least one space)
    name: Yup.string().required().matches(/^\s*[\S]+(\s[\S]+)+\s*$/gms,'Please enter your full name.'),
    email: Yup.string().email().required(),
    password: Yup.string().required().min(6,'At least six characters!'),
  }).required();

const formSchema2 = Yup.object()
  .shape({
    birthday: Yup.date().required(),
    gender: Yup.string().required(),
    country_id: Yup.object().required(),
    mobile_number: Yup.string().required("Mobile number is a required field!"),
  }).required();

const RegisterModal: React.FC<RegisterModalProps> = () => {
  const dispatch = useDispatch();
  const [cities, setCities] = useState<City[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [detailsUserInfo, setDetailsUserInfo] = useState<DetailsUserInfo>({ birthday: "", gender: "",mobile_number:"", city_id: null, terms: false });
  const [mainUserInfo, setMainUserInfo] = useState<MainUserInfo>({ name: "", email: "", password: "", is_interested_creator: false });
  const [viewMainInfo, setViewMainInfo] = useState<Boolean>(true);
  const [background, setBackground] = useState<any | null>(null);
  const [file, setFile] = useState<any | null>(null);
  const [hasError, setHasError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');


  const textInput = useRef<HTMLInputElement>(null);

  const show = useSelector<RootState, boolean>(
    (state) => state.ui.showRegisterModal,
  );

  const canClose = useSelector<RootState, boolean>(
    (state) => state.ui.canClose,
  );

  const onHide = useCallback(() => {
    if (canClose)
      dispatch(hideAuthModals());
  }, [dispatch,canClose]);

  function changeProfile() {
    if (textInput.current != null)
      textInput.current?.click();
  }

  function changeImage(event: any) {
    console.log(event);
    // setBackground(event.ta)
    var input = event.target;
    if (input.files && input.files[0]) {
      setFile(event.target.files[0])
      setBackground(URL.createObjectURL(event.target.files[0]))
    }
  }
  const onShowLoginModal = useCallback(() => {
    dispatch(showLoginModal(canClose));
  }, [dispatch]);

  const successLogin = useCallback( async (data) => {
    console.log("data")
    console.log(data)
    if (data['is_approved_policies'] == "Not Approved")
      dispatch(showContinueRegisterModal(data));
    else {
      dispatch(setUser(data));

      loginLocally(data.token);
      const usersFollow = await getUserFollower()

      dispatch(setUsersFollow(usersFollow));
      dispatch(hideAuthModals());
      window.location.reload(false);
    }
  }, [dispatch]);
  const backStep = useCallback(() => {
    setViewMainInfo(true)
  }, [dispatch]);
  const countryPayload = useSelector<RootState, Country[]>((state) => state.countries);

  useEffect(() => {
    (async () => {
      try {
        setViewMainInfo(true)
        pageTrack("sign_up_screen")
        // const countries = await getAllCountries("&limit=10000");
        setCountries(countryPayload);
      } catch (e) { }
    })();
  }, [countryPayload]);

  const handleChangeCountry = useCallback((item,setFieldValue) => {
    (async () => {
      setFieldValue('city_id','');
      let cities = await getAllCities("&country_id=" + item.value);
      setCities(cities);
    })();
  }, [])

  const handleSubmit = useCallback(
    (data: any, form: any) => {
      setHasError(false);
      setMainUserInfo(data);
      setViewMainInfo(false);
    },
    [dispatch]
  )

  const handleSubmit2 = useCallback(
    (data: any, form: any) => {
      return (async () => {

        setDetailsUserInfo(data)
        try {
          var form_data = new FormData();
          let mainData: RegistrationInfo = { ...mainUserInfo, ...data, "is_approved_policies": 0 };
          mainData.country_id = data['country_id'].value;
          mainData.city_id = data['city_id'].value;
          mainData.gender = data['gender'].value;
          
          mainData.mobile_number=data.mobile_number;
          mainData.is_interested_creator = mainData.is_interested_creator == true ? 0 : 1;

          //when city id is null 
          objectWithOutNull(mainData);
          Object.entries(mainData).forEach(([key, value]) => {
            form_data.append(key, value);
        });
          if (file){
            form_data.append("photo", file);
          }
            
          const { user, token } = await registerUser(form_data);
          track("sign_up")
          track("login")

          dispatch(setUser(user));
          loginLocally(token);
          dispatch(hideAuthModals());
        } catch (e) {
          console.log(e+"asdasd");
          setHasError(true);
          setErrorMessage(e as string);
          const err = formatJoiError(e);
          form.setErrors(err);
        }
      })();
    },
    [dispatch, mainUserInfo, file],
  );

  const classes = useStyles();
  return (
    <Modal
      dialogClassName={clsx(classes.modal, 'auth-modal')}
      centered
      show={show}
      onHide={onHide}
    >
      
      <Modal.Header className={classes.header} closeButton={canClose}>
        <Modal.Title>
          <Text className="m-0" color="white">
            SignUp
          </Text>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="px-4">
        { hasError ? (
          <Text className={clsx('my-2', classes.tomato)}>
            {errorMessage}
          </Text>)
           : (null)}
        {
          viewMainInfo ?
            <>
              <Formik
                // initialValues={{ name: '', email: '', password: '', terms: false }}
                initialValues={{ ...mainUserInfo}}
                onSubmit={handleSubmit}
                validationSchema={formSchema}
                validateOnChange
              >
                {({ handleSubmit, values, isValid, isSubmitting }) => (
                  <Form className={classes.formContainer} onSubmit={handleSubmit}>
                    <Text
                      className={clsx(classes.title,classes.paragraph, 'mb-4')}
                      uppercase
                    >
                      Signup with email
                    </Text>
                    <FormikErrorMessage name="name" />
                    <FormikTextField
                      name="name"
                      type="text"
                      placeholder="Full name"
                      className={classes.input}
                    />

                    <FormikErrorMessage name="email" />
                    <FormikTextField
                      name="email"
                      type="email"
                      placeholder="Email address"
                      className={classes.input}
                    />

                    <FormikErrorMessage name="password" />
                    <FormikTextField
                      name="password"
                      type="password"
                      placeholder="Password"
                      className={classes.input}
                    />

                    <div className={classes.termsBox}>
                      <FormikCheckbox
                        id="is_interested_creator"
                        name="is_interested_creator"
                        checked={values.is_interested_creator}
                      />
                      <label htmlFor="is_interested_creator">
                        <Text className={classes.requiredSpan} bold as="span">
                          request to join creator program
                        </Text>
                      </label>
                    </div>

                    <Button
                      type="submit"
                      disabled={!isValid || isSubmitting}
                      block
                      onClick={(e)=>{dispatch(changeStateOfClose(false))}}
                    >
                      <Text className="m-0" uppercase color="white">
                        Next
                      </Text>
                    </Button>
                  </Form>
                )}
              </Formik>
              <div className={classes.orDiv}>
                <span className={classes.orText}>OR</span>
              </div>
              <div className={classes.socialLogin}>
                <SocialLogin success={successLogin}></SocialLogin>
              </div>


              <Text bold align="center" color="black" className={clsx(classes.haveAccount,"my-3")}>
                Already have an account ?{' '}
                <button onClick={onShowLoginModal} className={classes.loginBtn}>
                  Login
                </button>
              </Text>
            </> : <>

              <input type="file" ref={textInput} onChange={e => changeImage(e)} className={classes.mediaFile} id="mediaFile" />
              <div className={classes.imageProfile}
                style={{
                  backgroundImage: `url(${(background) || `img/add-image.png`})`
                }}
                onClick={changeProfile}>
                {/* <img src={background}></img> */}
              </div>

              <Formik
                // initialValues={{ birthdate: '', gender: {}, city_id: {}, terms: false }}
                initialValues={{ ...detailsUserInfo }}
                onSubmit={handleSubmit2}
                validationSchema={formSchema2}
                validateOnChange        >

                {({ handleSubmit: handleSubmit2, values, isValid, isSubmitting,setFieldValue }) => (
                  <Form onSubmit={handleSubmit2}>

                    <FormikTextField
                      name="birthday"
                      type="date"
                      placeholder="Birthdate"
                      className={classes.input}
                    />
                    
                    <FormikSelect
                      className={classes.input}
                      name="gender"
                      placeholder="Select Gender"
                      options={[{
                        label: "Male",
                        value: "Male"
                      }, {
                        label: "Female",
                        value: "Female"
                      }]}
                    />
                    <FormikSelect
                      className={classes.input}

                      name="country_id"
                      change={(item:any)=>{handleChangeCountry(item,setFieldValue)}}
                      options={countries.map((country) => ({
                        label: country.long_name,
                        value: country.id
                      }))}
                      placeholder="Country"
                    // styles={{
                    //   control: (styles: any) => ({
                    //     ...styles,
                    //     backgroundColor: '#fff',
                    //     padding: '6px',
                    //     border: '2px solid #dadada',
                    //     borderRadius: 5,
                    //     width: '100%',
                    //   }),
                    // }}
                    />
                    <FormikSelect
                      className={classes.input}
                      name="city_id"
                      options={cities.length ? cities.map((city) => ({
                        label: city.name,
                        value: city.id,
                        areas: city.areas
                      })): [{label:"other",value:null}]}
                      placeholder="City"
                    />
                    <FormikErrorMessage name="mobile_number" />
                    <FormikTextField
                      name="mobile_number"
                      type="text"
                      placeholder="Mobile number"
                      className={classes.input}
                    />
                    
                    <div className={classes.termsBox}>
                      <FormikCheckbox
                        id="terms"
                        name="terms"
                        checked={values.terms}
                      />
                      <label htmlFor="terms">
                        <Text bold as="span">
                          I accept{' '}
                          <a
                            className={classes.paragraph}
                            href="https://twigbig.com/terms-and-conditions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Terms
                    </a>{' '}
                    and{' '}
                          <a
                            className={classes.paragraph}
                            href="https://twigbig.com/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Privacy Policy
                    </a>
                        </Text>
                      </label>
                    </div>

                    <Button
                      type="submit"
                      disabled={!isValid || !values.city_id ||!values.terms || isSubmitting}
                      block
                    >
                      <Text className="m-0" uppercase color="white">
                        Create Account
                </Text>
                    </Button>
                    {/* <Button
                     
                      block
                    > */}
                    <div onClick={backStep}>

                      <p className={clsx(classes.backBtn,"m-0")}>
                        Back
                      </p>
                    </div>
                    {/* </Button> */}

                  </Form>
                )}
              </Formik>

            </>
        }


      </Modal.Body>
    </Modal>
  );
};

const useStyles = createUseStyles({
  modal: {
    width: '100%',
    maxWidth: '500px',
  },
  '@media(max-width:580px)':{
    socialLogin:{
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
  },
  title:{
    fontSize: '18px',
    textAlign: 'center',
    fontWeight: '600',
    letterSpacing: '1px',
    textShadow: '2px 2px 5px rgb(0 0 0 / 30%), 0px -4px 10px rgb(255 255 255 / 30%)',
  },
  "@media (max-width:350px)":{
    input: {
      marginBottom: '0.5em',
    },
    requiredSpan:{
      fontSize:'11px',
    },
    
    haveAccount:{
      fontSize:'14px',
    },
  },
  formContainer:{

  },
  requiredSpan:{

  },
  haveAccount:{

  },
  header: {
    borderRadius: '5px !important',
    backgroundColor: '#522583',
    borderBottomLeftRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
    alignItems: 'center',
    marginBottom: '1px',
  },
  input: {
    marginBottom: '1rem',
    fontWeight: '500',
  },
  paragraph: {
    color: '#9D7CFA',
    '&:hover': {
      color: '#9D7CFA',
    },
    '&:visited': {
      color: '#9D7CFA !important',
      textDecoration: 'underline',
    },
  },
  termsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '0.5rem',
  },
  loginBtn: {
    color: '#9D7CFA',
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
    fontWeight: '600',
    '&:hover':{
      color:'#522583', 
    },
  },
  backBtn:{
    textAlign: 'center',
    color: '#9D7CFA',
    background: 'none',
    border: 'none',
    textDecoration: 'underline',
    fontWeight: '600',
    paddingTop:'10px',
    cursor: 'pointer',
    transition:'0.5s', 

    '&:hover':{
      color:'#522583',
      transition:'0.5s', 
    },
  },
  imageProfile: {
    width: "80px",
    height: "80px",
    backgroundColor: "white",
    margin: "0px auto",
    border: "3px dashed gray",
    marginBottom: "1rem",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  mediaFile: {
    display: "none",
    position: "absolute"
  },
  tomato: {
    color: 'tomato !important',
    fontSize: '1.2em',
  },
  bakcDiv: {
    textAlign: "center",
    width: "fit-content",
    margin: "0px auto",
    textDecoration: "underline"
  },
  orDiv: {
    height: "2px",
    backgroundColor: "#522583",
    margin: "22px 0px",
    position: "relative"
  },
  orText: {
    position: "absolute",
    left: "calc(50% - 17px)",
    top: "-10px",
    color: "#522583",
    backgroundColor: "white",
    padding: "0px 5px"
  },
  socialLogin: {
    display: "flex",
    justifyContent: "space-evenly"
  }
});

export default RegisterModal;
